import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EmqGetPasswordFormComponent } from "./emq-get-password/emq-get-password-form/emq-get-password-form.component";
import { SharedModule } from "@app/modules/shared/shared.module";
import { LemInfoListComponent } from './lem-info/list/lem-info-list/lem-info-list.component';
import { LemInfoFormComponent } from './lem-info/form/lem-info-form/lem-info-form.component';

@NgModule({
  declarations: [EmqGetPasswordFormComponent, LemInfoListComponent, LemInfoFormComponent],
  imports: [CommonModule, SharedModule.forRoot()],
})
export class OtherOperationsModule {}
